export function stripHtml(str: string): string {
	return str.replace(/<[^>]*>/g, '');
}

export function truncateString(str: string | undefined, targetSize: number): string | undefined {
	if (!str || str.length <= targetSize) return str;
	return `${stripHtml(str).substring(0, targetSize)}…`;
}

export function generateImagePath(src: string, opts?: { height?: number; width?: number }): string {
	return (
		'/media/' +
		(opts?.height && opts.width ? `rt:fill/` : '') +
		(opts?.height ? `h:${Math.floor(opts.height)}/` : '') +
		(opts?.width ? `w:${Math.floor(opts.width)}/` : '') +
		'q:85/' +
		btoa(src) +
		(src.endsWith('.svg') ? '' : '.webp')
	);
}
